<template>
  <div id="side-menu">
    <!-- this.$route.path -->
    <el-menu
      class="el-menu-vertical-demo"
      :default-active="sideActiveMenu"
      router
      @open="handleOpen"
      @close="handleClose"
    >
      <el-menu-item
        v-for="item in sideMenuData"
        :key="item.path"
        :index="item.path"
        >
        {{ $t(`menu.${item.title}`) }}
        <!-- {{ item.title }} -->
        </el-menu-item
      >
    </el-menu>
  </div>
</template>
<script>
import routes from "@/router";
import { arrayComparison } from "@/utils/validate";
import { mapState } from "vuex";
export default {
  props: {
    curRoute: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },

  computed: {
    ...mapState("user", ["roleName"]),
    sideMenuData() {
      const clickRoutes = routes.options.routes[1].children;
      const curFirstMenuActive = this.$route.meta.activeMenu;
      let curFirstMenuType;
      clickRoutes.some((item) => {
        if (item.path == curFirstMenuActive) {
          curFirstMenuType = item.meta.type;
        }
      });
      let sideRoute;
      sideRoute = clickRoutes.filter((item) => {
        return (
          item.meta.type == curFirstMenuType &&
          !item.meta.sideHidden &&
          arrayComparison(item.meta.roles, this.roleName)
        );
      });
      return sideRoute;
    },
    sideActiveMenu() {
      const clickRoutes = this.$route;
      const { meta, path } = clickRoutes;
      if (meta.sideActiveMenu) {
        return meta.sideActiveMenu;
      }
      return path;
    },
  },
  created() {},
  mounted() {},
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
  },
};
</script>

<style lang="scss" scoped>
#side-menu {
  height: calc(100vh - 32px - 78px);
  background-image: url("@/assets/images/common/bg_XiangYi.png");
  background-repeat: no-repeat;
  background-position: left 0 bottom 60px;
  background-color: #ffffff;
  .el-menu {
    padding: 10px 30px;
    border-right: unset;
  }
  .is-active {
    color: #ffffff;
    background: url("@/assets/images/common/sidebar_bg.png") no-repeat 100%;
    background-position: left;
  }
  .el-menu-item:hover,
  .el-menu-item:focus {
    background-color: unset;
  }
  .el-menu-item {
    font-size: 16px;
  }
}
</style>
